module.exports = {
      id: "clapboard-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#clapboard",
      toString: function () {
        return this.url;
      }
    }